"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var icons_1 = require("@tiendanube/icons");

require("./Card.css");

var __1 = require("..");

function Card(_a) {
  var title = _a.title,
      children = _a.children,
      primaryButton = _a.primaryButton,
      secondaryButton = _a.secondaryButton,
      isCollapsible = _a.isCollapsible,
      headerLabel = _a.headerLabel,
      Icon = _a.headerIcon,
      onClickHeaderIcon = _a.onClickHeaderIcon,
      isFluid = _a.isFluid;

  var _b = React.useState(false),
      open = _b[0],
      setOpen = _b[1];

  var handleCollapse = React.useCallback(function (e) {
    e.stopPropagation();
    setOpen(function (currentOpen) {
      return !currentOpen;
    });
  }, []);
  var memorizedPrimary = React.useMemo(function () {
    return primaryButton === "skeleton" ? React.createElement(__1.Stack.Item, null, React.createElement(__1.Button.Skeleton, null)) : (primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.onClick) && React.createElement(__1.Stack.Item, null, React.createElement(__1.Button, {
      onClick: primaryButton.onClick,
      appearance: "primary",
      spinner: primaryButton.spinner,
      disabled: primaryButton.disabled
    }, primaryButton.children));
  }, [primaryButton]);
  var memorizedSecondary = React.useMemo(function () {
    return secondaryButton === "skeleton" ? React.createElement(__1.Stack.Item, null, React.createElement(__1.Button.Skeleton, null)) : (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.onClick) && React.createElement(__1.Stack.Item, null, React.createElement(__1.Button, {
      onClick: secondaryButton.onClick,
      spinner: secondaryButton.spinner,
      disabled: secondaryButton.disabled
    }, secondaryButton.children));
  }, [secondaryButton]);
  var memorizedHeaderAction = React.useMemo(function () {
    return Icon && onClickHeaderIcon && React.createElement(__1.IconButton, {
      icon: Icon,
      ariaLabel: title,
      onClick: onClickHeaderIcon
    });
  }, [Icon, title, onClickHeaderIcon]);
  var memorizedHeaderLabel = React.useMemo(function () {
    return headerLabel === "skeleton" ? React.createElement(__1.Stack.Item, null, React.createElement(__1.Label.Skeleton, null)) : (headerLabel === null || headerLabel === void 0 ? void 0 : headerLabel.id) && React.createElement(__1.Label, {
      id: headerLabel.id,
      icon: headerLabel.icon,
      label: headerLabel.label,
      appearance: headerLabel.appearance,
      onClick: headerLabel.onClick
    });
  }, [headerLabel]);
  var memorizedCollapsibleButton = React.useMemo(function () {
    return isCollapsible && React.createElement("span", {
      className: "nimbus--card-header__collapse " + (open ? "is-open" : "")
    }, React.createElement(icons_1.ChevronDownIcon, null));
  }, [isCollapsible, open]);
  var memorizedChildren = React.useMemo(function () {
    return React.createElement(React.Fragment, null, children && React.createElement("div", {
      className: "nimbus--card-body"
    }, children), (secondaryButton || primaryButton) && React.createElement("div", {
      className: "nimbus--card-footer"
    }, React.createElement(__1.Stack, {
      spacing: "tight"
    }, memorizedSecondary, memorizedPrimary)));
  }, [children, memorizedPrimary, memorizedSecondary, primaryButton, secondaryButton]);
  var memorizedCollapsibleChildren = React.useMemo(function () {
    return React.createElement(React.Fragment, null, isCollapsible ? React.createElement("div", {
      className: "nimbus--card-collapse " + (open ? "is-open" : "")
    }, memorizedChildren) : React.createElement(React.Fragment, null, memorizedChildren));
  }, [isCollapsible, memorizedChildren, open]);
  var cardClassname = classnames_1.default("nimbus--card-wrapper", {
    "nimbus--input__fluid": isFluid
  });
  return React.createElement("div", {
    className: cardClassname
  }, isCollapsible ? React.createElement("button", {
    type: "button",
    "aria-label": "Expand",
    className: "nimbus--card-header is-collapsible",
    onClick: handleCollapse
  }, React.createElement("div", {
    className: "nimbus--card-header__title"
  }, React.createElement(__1.Title, {
    type: "h3"
  }, title)), memorizedHeaderLabel, memorizedHeaderAction, memorizedCollapsibleButton) : React.createElement("div", {
    className: "nimbus--card-header"
  }, React.createElement("div", {
    className: "nimbus--card-header__title"
  }, React.createElement(__1.Title, {
    type: "h3"
  }, title)), memorizedHeaderLabel, memorizedHeaderAction, memorizedCollapsibleButton), memorizedCollapsibleChildren);
}

exports.default = React.memo(Card);